import type { AccessToken, AccessTokenPayload, AuthenticatedCredentials, RefreshToken, Token } from "../domain";

export abstract class AuthenticatorProvider {
  abstract signInWithPassword(
    email: string,
    password: string
  ): Promise<AuthenticatedCredentials | { pendingToken: string }>;
  abstract signInWithMagicLink(email: string, code: string): Promise<AuthenticatedCredentials>;
  abstract signInWithValidationEmail(pendingToken: string, code: string): Promise<AuthenticatedCredentials>;
  abstract signInWithTOTP(pendingToken: string, challenge: string, code: string): Promise<AuthenticatedCredentials>;
  abstract requestRefreshToken(accessToken: AccessToken, refreshToken: RefreshToken): Promise<AuthenticatedCredentials>;
  abstract signOut(accessToken: AccessToken, refreshToken: RefreshToken): Promise<{ success: boolean }>;
  abstract validateToken(token: Token): Promise<{ valid: boolean }>;
  abstract extractAccessToken(accessToken: AccessToken): AccessTokenPayload;
  abstract requestPasswordReset(email: string): Promise<void>;
  abstract resetPassword(pendingToken: string, password: string): Promise<void>;
}
